exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-counter[data-v-69ab50d6]{margin-left:2em}", ""]);

// exports
